import { inject, Injectable } from '@angular/core';
import type {
  SrmCategoryTreeModel,
  SrmFileModel,
  SrmTicketCreateModel,
  SrmTicketListModel,
  SrmTicketModel,
  SrmTicketSuggestionModel,
  SrmTicketSuggestionRequestModel,
} from '@libs/services/models';
import { FileUploadModel, SingleStepFormItemModel } from '@libs/form/models';
import { Observable } from 'rxjs';
import { SrmRepositoryService } from './srm-repository.service';

@Injectable({
  providedIn: 'root',
})
export class SrmService {
  private readonly srmRepositoryService: SrmRepositoryService = inject(SrmRepositoryService);

  public getCategoryTree(location?: string): Observable<SrmCategoryTreeModel[]> {
    return this.srmRepositoryService.getCategoryTree(location);
  }

  public getDetailsStep(formIdentifier: string): Observable<SingleStepFormItemModel> {
    return this.srmRepositoryService.getForm(formIdentifier);
  }

  public createTicket(ticket: SrmTicketCreateModel): Observable<SrmTicketModel> {
    return this.srmRepositoryService.createTicket(ticket);
  }

  public getTicket(ticketIdentifier: string): Observable<SrmTicketModel | undefined> {
    return this.srmRepositoryService.getTicket(ticketIdentifier);
  }

  public getTickets(): Observable<SrmTicketListModel | undefined> {
    return this.srmRepositoryService.getTickets();
  }

  public uploadFile(file: File): Observable<FileUploadModel> {
    return this.srmRepositoryService.uploadFile(file);
  }

  public getFile(fileIdentifier: string): Observable<SrmFileModel> {
    return this.srmRepositoryService.getFile(fileIdentifier);
  }

  public getTicketSuggestion(request: SrmTicketSuggestionRequestModel): Observable<SrmTicketSuggestionModel> {
    return this.srmRepositoryService.getTicketSuggestion(request);
  }

  public getTicketSuggestionFile(fileIdentifier: string): Observable<SrmFileModel> {
    return this.srmRepositoryService.getTicketSuggestionFile(fileIdentifier);
  }
}
